import { FC } from "react";

import PersonelInfo from "./PersonelInfo";
import Otp from "components/Auth/Otp/Otp";
import PasswordSuccess from "./PasswordSuccess";
import CardPassInfo from "./CardPassInfo";
import NewPassPersonelInfo from "./NewPassPersonelInfo";

type StepProp = {
  stepNumber: number;
};

const STEP_INDEXES: any = {
  0: <NewPassPersonelInfo first={true} />,
  1: <Otp fromGetPassword={true} />,
  2: <PasswordSuccess />,

  // 0: <PersonelInfo first={true} />,
  // 1: <CardPassInfo />,
  // 2: <Otp fromGetPassword={true} />,
  // 3: <PasswordSuccess />,
};

export const ChangeStep: FC<StepProp> = ({ stepNumber }) => {
  return STEP_INDEXES[stepNumber];
};
